export default "__VITE_ASSET__02T6WBLg__"